<script setup>
/* eslint-disable */
</script>
<template>
    <svg class="stroke" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99984 1.16669V12.8334M1.1665 7.00002H12.8332" stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

